export default {
      id: "logo-usage",
      viewBox: "0 0 210 98",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#logo",
      toString: function () {
        return this.url;
      }
    }